/**********************************

Cookie functions - worldpantry-inventory.js file  (GOOD EARTH)

  ZIP ACQUISITION: assets/worldpantry-ipzipcode.js (the boss's app-proxy
  file) sets the `zipcode` cookie. The old inline IPStack call and its
  EXPOSED access_key have been REMOVED, along with geoTarget()/setTimeout
  and the leaked `var zipcode` global.

  AUTO-TRIGGER + BUTTON: the shipping form is now a DIV with a
  <button type="button"> (the shared panel), not a <form>. The auto-trigger
  fills the zip input and CLICKS the button (the shared logic listens for
  that click), then verifies the lookup stored a result and retries if the
  click raced ahead of the handler binding. It does NOT call .submit().

***********************************/

// Sets a cookie with the given name and value for the current session.
function setSessionCookie(name, value) {
  document.cookie = name + "=" + encodeURIComponent(value) + "; path=/; SameSite=Lax; Secure";
}

// Gets a cookie with the given name.
function getSessionCookie(name) {
  const nameKey = name + "=";
  const cArr = document.cookie.split('; ');
  let res;
  cArr.forEach(val => {
    if (val.indexOf(nameKey) === 0) res = decodeURIComponent(val.substring(nameKey.length));
  });
  return res;
}

// Deletes a cookie (the shared logic + self-heal require this).
function deleteCookie(name) {
  document.cookie = name + "=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; SameSite=Lax; Secure";
}

function getCookie(name) {
  var nameEQ = name + "=";
  var ca = document.cookie.split(';');
  var result = null;
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) === ' ') c = c.substring(1);
    if (c.indexOf(nameEQ) === 0) result = decodeURIComponent(c.substring(nameEQ.length));
  }
  return result;
}

function setCookie(name, value, days) {
  var expires = "";
  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    expires = "; expires=" + date.toUTCString();
  }
  var encodedValue = value != null ? encodeURIComponent(value) : "";
  document.cookie = name + "=" + encodedValue + expires + "; path=/; SameSite=Lax; Secure";
}

function isValidZip(str) {
  return /^\d{5}(-\d{4})?$/.test(str || "");
}

/**********************************
  Self-heal: clear a stuck "No Error" cookie and legacy/stale date cookies
  (non-ISO, or a receive-by date now in the past from a previous visit) so
  the auto-trigger refetches a fresh date instead of painting a stale one.
***********************************/
(function selfHealFastShipCookies() {
  var err = getSessionCookie('FastShip.FastShipCalculationError');
  if (err) {
    var zip = getSessionCookie('FastShip.ZipCode');
    if (err === "No Error" || !isValidZip(zip)) {
      deleteCookie('FastShip.FastShipCalculationError');
    }
  }

  var receiveBy = getSessionCookie('FastShip.ReceiveByDateTime');
  var orderBy = getSessionCookie('FastShip.OrderByDateTime');

  // Non-ISO legacy value -> unparseable -> clear.
  if ((receiveBy && isNaN(new Date(receiveBy))) ||
      (orderBy && isNaN(new Date(orderBy)))) {
    deleteCookie('FastShip.ReceiveByDateTime');
    deleteCookie('FastShip.OrderByDateTime');
    return;
  }

  // Stale PAST date from a previous visit -> clear (day granularity).
  if (receiveBy) {
    var rd = new Date(receiveBy);
    if (!isNaN(rd)) {
      var today = new Date();
      today.setHours(0, 0, 0, 0);
      var day = new Date(rd.getFullYear(), rd.getMonth(), rd.getDate());
      if (day.getTime() < today.getTime()) {
        deleteCookie('FastShip.ReceiveByDateTime');
        deleteCookie('FastShip.OrderByDateTime');
      }
    }
  }
})();

/**********************************
  Auto-trigger (race-proof). Fires the lookup once a VALID zip cookie lands
  (the proxy sets it from an async fetch), by filling the zip input and
  CLICKING the panel's button, then verifying + retrying if the click raced
  the shared logic's handler binding. Guarded to run once.
***********************************/
$(document).ready(function () {
  if (window.wpZipAutoTriggered) return;
  window.wpZipAutoTriggered = true;

  var zipInputSelector  = '.zip_input';
  var zipButtonSelector = '.zip_button';

  var zipPollTicks = 0;
  var zipPollMax = 40;          // ~10s waiting for the async proxy zip
  var clickTries = 0;
  var clickMax = 10;            // retry the click if it raced the handler

  function resultStored() {
    return !!getSessionCookie('FastShip.ReceiveByDateTime');
  }

  function fireAndVerify(zip) {
    if (resultStored()) return;

    console.log("fast geo zip " + zip + (clickTries ? " (retry " + clickTries + ")" : ""));
    $(zipInputSelector).val(zip);
    var $btn = $(zipButtonSelector).first();
    if ($btn.length) $btn.trigger("click");

    clickTries++;
    if (clickTries < clickMax) {
      setTimeout(function () {
        if (!resultStored()) fireAndVerify(zip);
      }, 300);
    }
  }

  function waitForZip() {
    var zip = getCookie('zipcode');
    if (isValidZip(zip)) {
      fireAndVerify(zip);
      return;
    }
    zipPollTicks++;
    if (zipPollTicks < zipPollMax) {
      setTimeout(waitForZip, 250);
    } else {
      console.log("no zipcode after polling - manual entry only");
    }
  }

  waitForZip();
});

/**********************************

Product Inventory functions

***********************************/

const OutOfStockAlwaysSellStatusDisplay = "Usually ships in 1-2 weeks.";
const OutOfStockAlwaysSellCartStatusDisplay = 'Alert: Item(s) highlighted below should be back in stock in 1-2 weeks. Remove or replace them to have your order ship now.';
const OutOfStockAlwaysSellCartItemStatusDisplay = 'More stock expected in 1-2 weeks - will delay your entire order';

// Builds the In Stock display HTML with the arrival month baked in from the
// FastShip.OrderByMonth cookie. Was previously a static const string with an
// empty <span>, which relied on the shipping bar's $('.arrival_month').text()
// running AFTER the HTML was inserted -- a race condition. By building it as
// a function we capture the date at render time instead.
function getInStockAlwaysSellStatusDisplay() {
  var arrivalMonth = getSessionCookie('FastShip.OrderByMonth') || '';
  return "In Stock" +
    "</br>" +
    "<div id='shipping-message' class='shipping-message'>" +
      "<p id='cta_order_by'>For your area - Arrives" +
        "<strong class='arrival_month'><span>" + arrivalMonth + "</span></strong>" +
      "</p>" +
    "</div>";
}

// Gets product inventory JSON data from shop.worldpantry.com and calls the given setProductInventoryStatus function
function getProductInventoryDisplay(zip, productId, variantId, setProductInventoryStatus) {
  var url = 'https://shop.worldpantry.com/productinventories/goodearth/productinventory.aspx';
  var postproductinventory = $.post(url, { zip: zip, key: 'WP_2021_GOODEARTH', productid: productId, variantid: variantId });
  postproductinventory.done(function (data) {
    if (data) {
      if (data.Status == 'OutOfStock' || data.Status == 'AlwaysSell') {
        data.StatusDisplay = OutOfStockAlwaysSellStatusDisplay;
      }
      setProductInventoryStatus(data);
    }
  });
}

// Gets WorldPantry product number and variant number for each item in the
// current cart. Returns a Promise that resolves to the parsed array.
function getProductNumbers() {
  return $.ajax({
    type: 'GET',
    url: '/cart?view=wp-productnumbers'
  }).then(function (response) {
    try {
      return JSON.parse(response);
    } catch (e) {
      console.error('getProductNumbers: failed to parse response', e);
      return null;
    }
  });
}

// Gets product inventories for the given list of WorldPantry product/variant
// numbers. Returns a Promise that resolves to the inventory array (or null
// when called with no items).
function getProductInventories(productNumbers) {
  if (!productNumbers || !productNumbers.length) {
    return $.Deferred().resolve(null).promise();
  }

  var items = [];
  for (var i = 0; i < productNumbers.length; i++) {
    items.push({
      productId: productNumbers[i].productNumber,
      variantId: productNumbers[i].variantNumber
    });
  }

  var shippingInfo = {
    zip: getCookie('zipcode'),
    items: items
  };
  var url = 'https://shop.worldpantry.com/productinventories/goodearth/productinventories.aspx';

  return $.ajax({
    type: 'POST',
    url: url,
    data: { key: 'WP_2021_GOODEARTH', shippingInfo: JSON.stringify(shippingInfo) }
  });
}

// Gets a product inventory status display for the cart item.
function getProductInventoryCartItemStatusDisplay(productInventory) {
  var inventoryCartItemStatusDisplay = 'In Stock';
  if (productInventory) {
    if (productInventory.Status == 'AlwaysSell' || productInventory.Status == 'OutOfStock') {
      inventoryCartItemStatusDisplay = OutOfStockAlwaysSellCartItemStatusDisplay;
    }
  }
  return inventoryCartItemStatusDisplay;
}

// Gets a product inventory status display for the cart.
function getProductInventoryCartStatusDisplay(productInventories) {
  var inventoryCartStatusDisplay = '';
  if (productInventories) {
    for (var i = 0; i < productInventories.length; i++) {
      if (productInventories[i].Status == 'AlwaysSell' || productInventories[i].Status == 'OutOfStock') {
        inventoryCartStatusDisplay = OutOfStockAlwaysSellCartStatusDisplay;
        break;
      }
    }
  }
  return inventoryCartStatusDisplay;
}

// Gets a product inventory for the given item ID.
// Guarded: skips records missing ProductId/VariantId rather than throwing
// on .toUpperCase() of undefined.
function getProductInventory(id, productNumbers, productInventories) {
  var inventoryStatus;
  for (var n = 0; n < productNumbers.length; n++) {
    if (productNumbers[n].id == id) {
      var productNumber = productNumbers[n].productNumber;
      var variantNumber = productNumbers[n].variantNumber;
      for (var i = 0; i < productInventories.length; i++) {
        if (productInventories[i].ProductId &&
            productInventories[i].VariantId &&
            (productInventories[i].ProductId.toUpperCase() == productNumber.toUpperCase()) &&
            (productInventories[i].VariantId.toUpperCase() == variantNumber.toUpperCase())) {
          inventoryStatus = productInventories[i];
          if (inventoryStatus.Status == "OutOfStock") {
            inventoryStatus.StatusDisplay = OutOfStockAlwaysSellStatusDisplay;
          } else {
            inventoryStatus.StatusDisplay = getInStockAlwaysSellStatusDisplay();
          }
          break;
        }
      }
      break;
    }
  }
  return inventoryStatus;
}

/**********************************

Start Reload Cart Page with Live Inventory

***********************************/

var firstChange = true;

function reloadCart() {
  var target = document.querySelector('[data-subtotal]');
  if (!target) return;
  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function () {
      if (firstChange) {
        firstChange = false;
        return;
      } else {
        firstChange = true;
        // NOTE: original code was `setTimeout(window.location.reload())`,
        // which invokes reload() immediately (its return value, undefined,
        // is what gets passed to setTimeout). Behavior preserved.
        window.location.reload();
      }
    });
  });
  var config = { attributes: true, childList: true, characterData: true };
  observer.observe(target, config);
}

document.addEventListener("DOMContentLoaded", function () {
  reloadCart();
});
